import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { DataGridFlexSales, useDataGridFlexSales, useDataGridSync } from '../../DataGridFlexSales';

import {
  reportFilterCountryCodeSelector,
  reportSalesJournalThirdPartySelector,
} from '../../../state';
import handlerFactory, { ThirdPartyDataGridContext } from './handlerFactory';
import { SalesJournalThirdParty } from '../../../types';

const DataGridConfig = () => {
  const { handler } = useDataGridFlexSales<SalesJournalThirdParty, ThirdPartyDataGridContext>();

  const { t } = useTranslation();
  const title = t('sales-journal.title');
  const country = useSelector(reportFilterCountryCodeSelector);
  const gcsResource = useSelector(reportSalesJournalThirdPartySelector);

  const { data, loading } = gcsResource;

  const gridContext = useMemo(
    () => ({
      t,
      country,
    }),
    [t, country]
  );

  useDataGridSync({
    handler,
    data,
    context: gridContext,
    title,
    loading,
  });

  return null;
};

const FcsDataGrid = () => (
  <DataGridFlexSales handlerFactory={handlerFactory} hideToolbar>
    <DataGridConfig />
  </DataGridFlexSales>
);

export default FcsDataGrid;
